<template>
<div>
  <div class="modal">
    <div class="modal-dialog">
      <div :class="{ 
        'modal-content': true, 
        'modal-warning': true,
        }">
        <div class="modal-body text-center" v-html="message">
        </div>
        <div class="modal-footer">
          <div class="btn" @click="yes">確定</div>
          <div class="btn" @click="no">取消</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Confirm',
  props: ['message'],
  methods: {
    yes() {
      this.$emit('response', true);
    },
    no() {
      this.$emit('response', false);
    },
  },
};
</script>

<style lang="sass" scoped>
.modal
  display: flex
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.3);

.modal-dialog
  // margin-top: 300px !important
  width: 500px !important

.modal-error
  border-color: #FF3811
  background-color: #FF3811
  color: white

.modal-warning
  border-color: #ff960c
  background-color:#ff960c
  color: white

.modal-success
  border-color: #42b883
  background-color: #42b883
  color: white  

.modal-footer
  justify-content: center
  border: 0
  .btn
    border: 1px solid white

.modal-body
  p
    margin-bottom: 0
</style>




// WEBPACK FOOTER //
// Confirm.vue?0b0aad2e